export function containsUppercase(text) {
  const containsLetterRegex = new RegExp('([A-Z])');
  return containsLetterRegex.test(text);
}

export function containsLowercase(text) {
  const containsLetterRegex = new RegExp('([a-z])');
  return containsLetterRegex.test(text);
}
export function containsNumber(text) {
  const containsNumberRegex = new RegExp('([0-9])');
  return containsNumberRegex.test(text);
}

export function containsSymbol(text) {
  const containsSymbolRegex = new RegExp('(?=.*[!@$%^&*()<>{}|+=])');
  return containsSymbolRegex.test(text);
}

export function isMinLength(text, minLength = 0) {
  const isMinLengthRegex = new RegExp(`(?=.{${minLength},})`);
  return isMinLengthRegex.test(text);
}

export function isMaxLength(text, maxLength = 0) {
  const isMaxLengthRegex = new RegExp(`(?=^.{0,${maxLength}}$)`)
  return isMaxLengthRegex.test(text);
}

export function numberAndDotOnly(text) {
  return /^(\d+\.\d+|\.?\d+){1,}$/g.test(text);
}

export function hasValue(text) {
  return text !== null && text !== undefined && text.trim() !== '';
}

export function validateEmail(value: string) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
}

export function validatePasscode(value: string) {
  const emailRegex = /^\d{6}$/;
  return emailRegex.test(value);
}

